<template>
  <b-card-header class="pt-1 pl-1 pb-1 border-bottom">
    <b-card-title>
      <div
        v-if="cardTitle"
        class="font-medium-1"
      >
        {{ cardTitle }}
      </div>
      <div class="font-small-4 text-muted">
        {{ cardSubTitle }}
      </div>
    </b-card-title>
    <div>
      <b-button
        v-if="refreshData"
        v-b-tooltip.hover.top="tooltipText"
        variant="flat-secondary"
        pill
        size="sm"
        class="btn-icon"
        @click="refreshData(dataType)"
      >
        <FeatherIcon icon="RefreshCwIcon" />
      </b-button>
    </div>
  </b-card-header>
</template>
<script>
import {
  BCardHeader, BCardTitle, BButton, VBTooltip,
} from 'bootstrap-vue'

export default {
  name: 'CardCustomHeader',
  components: {
    BCardHeader, BCardTitle, BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    cardTitle: {
      type: String,
      default: null,
    },
    cardSubTitle: {
      type: String,
      default: null,
    },
    tooltipText: {
      type: String,
      default: null,
    },
    dataType: {
      type: String,
      required: true,
    },
    refreshData: {
      type: Function,
      default: null,
    },
  },
}
</script>
